import React from "react";

type Props = {
    title: string;
    value: number | string;
    loading?: boolean;
    error?: string | null;
    icon?: React.ReactNode;
    className?: string;
    onClick?: () => void;
};

export const ProviderStatCard: React.FC<Props> = ({
    title,
    value,
    loading = false,
    error = null,
    icon,
    className = "",
    onClick,
}) => {
    const cardClasses = [
        "rounded-2xl border bg-white p-6 shadow-sm",
        className,
        onClick ? "cursor-pointer transition-colors hover:bg-gray-50" : "",
    ].join(" ");

    return (
        <div className={cardClasses} onClick={onClick}>
            <div className="flex items-center justify-between mb-4">
                <h3 className="text-sm font-medium text-gray-500">{title}</h3>
                {icon && <div className="text-gray-400">{icon}</div>}
            </div>
            {loading ? (
                <div className="h-8 w-24 animate-pulse rounded bg-gray-100" />
            ) : error ? (
                <div className="text-sm text-rose-600">{error}</div>
            ) : (
                <div className="text-2xl font-bold tracking-tight text-gray-900">
                    {value}
                </div>
            )}
        </div>
    );
};
